import React, { Component, Fragment } from 'react';
import EnhancedTable from '../general/table.js';
import Config from '../config.js';
import { Card, Toolbar, Grid, Button, Typography, Dialog, DialogContent, DialogActions, MenuItem, LinearProgress, withStyles, IconButton, Chip } from '@material-ui/core';
import DocType from '../general/document_type.js';
import axios from 'axios';
import ExtendedField from '../general/text_field.js';
import ExtendedSelect from '../general/select_field.js';
import { Form, Field } from 'react-final-form';
import { sandboxCss } from '../helpers.js';
import Auth from '../auth.js';
import ConfirmDialog from '../general/confirm_dialog.js';
import {stringify} from 'csv-stringify/lib/sync';
import FileSaver from 'filesaver.js-npm';
import cronstrue from 'cronstrue';
import { Alert } from "@material-ui/lab";
import { Link } from 'react-router-dom';
import { AddCircleOutline } from "@material-ui/icons";
import InfoIcon from '@material-ui/icons/Info';
import ScheduleIcon from '../images/schedule.svg';
import createDecorator from 'final-form-calculate';
import Moment from 'react-moment';
import { loadProfiles } from '../files/export.js';

const tableStyles = {
    root: {
        "& .lbtoolbar": {
        display: "none"
        }
    }
}

const StyledTable = withStyles(tableStyles)(EnhancedTable);

const reportDescriptions = {
    ClientActivityReport: "Lists document activity over the past 8 days, including documents, orders, open orders, shipments, and invoices.",
    DetailedOpenOrderReport: "Lists open orders by partner categorized into: <7 days, 7-14, 14-30, 30-60, >60 days.",
    DocumentAgingReport: "Lists incomplete documents by partner categorized into: <7 days, 7-14, 14-30, 30-60, >60 days.",
    FuncAckReport: "Lists documents missing a Functional Acknowledgement (997) from a partner after 48 hours.",
    InventoryUnmatchedReport: "Lists unmatched inventory items for all partners. Used only for retailers.",
    InventoryUpdateReport: "Lists inventory details by partner, including total items, total updates, matched items, matched updates, unmatched items, in-stock percentage, and last update.",
    MonthlyDocumentReport: "Monthly summary of all documents processed (orders, acknowledgements, shipments, invoices).",
    MonthlyOrderReport: "Monthly summary of all orders processed.",
    NewDocumentActivityReport: "Monitors expected document volume over a 24-hour period. If volume falls below a threshold (e.g., <400 orders), an alert is triggered.",
    OpenDocumentReport: "Lists open documents not yet completed. Similar to the aging report, limited to a max of 50 documents.",
    ScoreCardReport: "Weekly summary of partner performance: overall score, ship time, ship %, cancel %. Used only for retailers.",
    ShippedOrderAgingReport: "Lists orders with shipments applied but not all items have been shipped.",
    SubmittedDocumentReport: "Lists documents stuck in \"Submitted\" status for over 1 hour, indicating possible connection issues.",
    UnshippedOrderReport: "Lists orders that have not shipped within 72 hours of the Requested Ship Date, limited to a max of 50 orders.",
    CustomExportReport: "Exports documents to a CSV file using a customizable export template and provides a link in the generated event."
};

const reportNameOverrides = {
    DetailedOpenOrderReport: "Open Order Details",
    DocumentAgingReport: "Document Aging Report",
    FuncAckReport: "Overdue FuncAcks",
    InventoryUnmatchedReport: "Unmatched Inventory Report",
    InventoryUpdateReport: "Inventory Update Report",
    MonthlyOrderReport: "Monthly Order Report",
    NewDocumentActivityReport: "New Document Activity",
    OpenDocumentReport: "Overdue Documents",
    ShippedOrderAgingReport: "Shipped Order Aging Report",
    CustomExportReport: "Custom Report"
}

const reportDocumentTypes = {
    DetailedOpenOrderReport: "Order",
    MonthlyOrderReport: "Order",
    ShippedOrderAgingReport: "Order",
    UnshippedOrderReport: "Order"
};

class Monitoring extends Component {
    state = {showEdit: false, showConfirm: false, disableConfirm: false, disableEdit: false, showReport: false, tables: [], showReportDetails: false, profiles:  []};
    thresholds = {
        MonthlyDocumentReport: true,
        MonthlyOrderReport: true,
        NewDocumentActivityReport: true
    }
    documentTypes = {
        DocumentAgingReport: true,
        FailedDocumentReport: true,
        FuncAckReport: true,
        NewDocumentActivityReport: true,
        OpenDocumentReport: true,
        SubmittedDocumentReport: true,
        CustomExportReport: true
    }
    exportProfiles = {
        CustomExportReport: true
    }
    async componentDidMount(){
        let profiles = (await loadProfiles()).filter(r => !(!r.Id));
        this.setState({profiles});
    }
    save = async (report) => {
        if(this.state.report.ReportId && report.ReportId && (report.ReportId !== this.state.report.ReportId || (report.DocumentType && report.DocumentType !== this.state.report.DocumentType))){
            report.ReportName = null;
            await this.delete(this.state.report);
        }
        try{
            if(report.ReportName){
                await axios.put(Config.api + "/odata/Company/ReportConfigurations", report);
            }else{
                await axios.post(Config.api + "/odata/Company/ReportConfigurations", report);
            }
        }catch {

        }
        await this.setState({refresh: !this.state.refresh, disableEdit: false, showEdit: false, report: null});
    }
    delete = async (report) => {
        await this.setState({disableConfirm: true});
        try {
            await axios.delete(Config.api + "/odata/Company/ReportConfigurations", { data: report });
        } catch {

        }
        await this.setState({refresh: !this.state.refresh, disableConfirm: false, showConfirm: false, report: null});
    }
    runReport = async (report) => {
        this.setState({showReport: true, report: report, result: null});
        let request = {documentType: report.DocumentType, reportId: report.ReportId, threshold: report.Threshold, exportProfile: report.ExportProfile};
        let result = (await axios.post(Config.api + "/odata/Company/Functions.RunReport", request)).data;
        let tables = [];
        if(result.Error){
            result = result.Error;
        }
        else if(result.Events && result.Events.length > 0){
            let html = document.createElement("html");
            html.innerHTML = result.Events[0].Body;
            let htmlTables = html.querySelectorAll("table") || [];
            let i = 0;
            htmlTables.forEach(table => {
                let headers = [...(table.querySelectorAll("th") || [])].map(r => r.innerText);
                if(headers.length === 0){
                    return;
                }
                let rawRows = [...(table.querySelectorAll("tr") || [])];
                let rows = [headers].concat(rawRows.map(r => [...(r.querySelectorAll("td") || [])].map(x => x.innerText))).filter(r => r && r.length > 0);
                tables.push({name: "Report " + (i+1), rows});
                i++;
            });
            result = sandboxCss(result.Events[0].Body, "detailsModalBody");
        }else{
            result = "This report either did not generate a result or the results are meant to be sent to your trading partner.";
        }
        this.setState({result: result, tables});
    }
    enableThreshold = (reportId) => {
        if(reportId === undefined || reportId === null){
            return false;
        }
        if(this.state.definitions){
            var def = this.state.definitions.find(r => r.Id === reportId);
            if(def && this.thresholds[def.ReportName]){
                return true;
            }
        }
        return false;
    }
    enableDocType = (reportId) => {
        if(reportId === undefined || reportId === null){
            return false;
        }
        if(this.state.definitions){
            var def = this.state.definitions.find(r => r.Id === reportId);
            if(def && this.documentTypes[def.ReportName]){
                return true;
            }
        }
        return false;
    }
    enableExportProfile = (reportId) => {
        if(reportId === undefined || reportId === null){
            return false;
        }
        if(this.state.definitions){
            var def = this.state.definitions.find(r => r.Id === reportId);
            if(def && this.exportProfiles[def.ReportName]){
                return true;
            }
        }
        return false;
    }
    showDeleteConfirm = (row) => {
        let message = `Are you sure you want to delete this ${row.ReportAlias}`;
        if(row.ReportAlias && row.ReportAlias.toLowerCase().endsWith("report")){
            message += "?";
        } else {
            message += " report?";
        }
        this.setState({showConfirm: true, disableConfirm: false, report: row, confirmMessage: message});
    }
    print = () => {
        let printWindow = window.open('', this.state.report.ReportAlias, 'height=400,width=600');
        printWindow.document.body.innerHTML = '<h1>' + this.state.report.ReportAlias  + '</h1>'
        + document.getElementById("reportContent").innerHTML;
        printWindow.document.close();
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    }
    export = (name, rows) => {
        let output = stringify(rows);
        let blob = new Blob([output], { type: "text/csv" });
        FileSaver.saveAs(blob, name + ".csv");
    }
    parseSchedule(schedule){
        try{
            let parsed = cronstrue.toString(schedule);
            if(/^At \d\d:\d\d (AM|PM)$/.test(parsed)){
                parsed = parsed.replace('At', 'Daily at');
            }
            return parsed;
        }catch{}
    }
    onReportClick = async (report) => {
        this.setState({showReportDetails: true, report: {...report, Description: reportDescriptions[report.ReportName]}});
    }
    calculator = createDecorator(
        {
            field: /ReportAlias/,
            updates: (value, name, allValues) => {
                if(!value){
                    return;
                }
                let reports = this.state.definitions.filter(r => r.ReportAlias === value);
                let first = reports.filter(r => r.Id === allValues.ReportId || r.Schedule === allValues.Schedule)[0] || reports[0];
                return {
                    ReportId: first.Id,
                    DocumentType: allValues.DocumentType || 'Order',
                    ExportProfile: null,
                    Threshold: this.enableThreshold(first.Id) ? allValues.Threshold : null
                };
            }
        },
        {
            field: /DocumentType/,
            updates: (value, name, allValues) => {
                if(!value){
                    return;
                }
                let profile = (this.state.profiles.filter(r => r.DocumentType === value && r.Name === allValues.ExportProfile)[0] || {}).Name || null;
                return {
                    ExportProfile: profile
                };
            }
        }
    )
    newReport = () => {
        let firstReport = this.state.definitions[0];
        this.setState({showEdit: true, disableEdit: false, report: {ReportId: firstReport.Id, ReportAlias: firstReport.ReportAlias}});
    }
    render(){
        let canManageSettings = Auth.hasPermission('settings/manage');
        let cols = [
          { id: 'ReportAlias', sortable: true, label: 'Report', template: (value, row) => <>{value} {row.ExportProfile ? `(${row.ExportProfile})` : ''} <IconButton style={{position: 'absolute', marginTop: '-4px'}} color='primary' onClick={() => this.onReportClick(row)} size="small"><InfoIcon fontSize="inherit" /></IconButton></> },
          { id: 'DocumentType', sortable: true, label: 'Document Type', width: '15em', template: (value, row) => this.enableDocType(row.ReportId) || reportDocumentTypes[row.ReportName] ? <DocType docType={value || reportDocumentTypes[row.ReportName]}/>: '' },
          { id: 'Threshold', sortable: true, label: 'Threshold', width: '12em' },
          { id: 'Schedule', label: 'Schedule (UTC)'},
          { id: 'LastRunTime', type:'date', sortable: true, label: 'Last Ran (Your Time)', template: (value) => (value ? <Moment format='MM/DD/YYYY hh:mm A'>{value}</Moment> : ''), width: '13em' }
        ];
        if(canManageSettings){
            cols.push({ command: 'commands', stopPropagation: 'true', width: '19em', template: (value, row) => (
                <Fragment>
                    <Button size='small' variant='contained' onClick={() => this.runReport(row)}>Preview</Button>
                    <Button style={{marginLeft: '0.5rem'}} size='small' variant='contained' onClick={() => this.setState({showEdit: true, disableEdit: false, report: row})}>Edit</Button>
                    <Button style={{marginLeft: '0.5rem'}} size='small' variant='contained' onClick={() => this.showDeleteConfirm(row)}>Delete</Button>
                </Fragment>
            )});
        }
        let config = {
            columns: cols,
          getData: async () => {
              let definitions = this.state.definitions;
              if(!definitions){
                  definitions = (await axios.get(Config.api + "/odata/Company/ReportDefinitions?$select=Id,Description,ReportName,Schedule&$orderby=Description")).data.value;
                  definitions.forEach(r => {
                    r.ReportAlias = reportNameOverrides[r.ReportName] || r.Description;
                    r.Schedule = this.parseSchedule(r.Schedule)
                });
                  let reportNames = definitions.map(r => r.ReportAlias)
                  reportNames = reportNames.filter((r, i) => reportNames.indexOf(r) === i).sort((a, b) => a.localeCompare(b));
                  this.setState({definitions, reportNames});
              }
              let reports = (await axios.get(Config.api + "/odata/Company/ReportConfigurations")).data.value;
              return reports.map(r => ({
                  ...r,
                  ReportName: definitions.find(x => x.Id === r.ReportId).ReportName,
                  ReportAlias: definitions.find(x => x.Id === r.ReportId).ReportAlias,
                  Schedule: definitions.find(x => x.Id === r.ReportId).Schedule,
              }));
          },
          order: 'asc',
          orderBy: 'ReportAlias',
          keyField: (value) => value.ReportId + value.DocumentType,
          pageSize: 20,
          pageSizes: [10, 20, 50],
          refresh: this.state.refresh
        }
        let creatingReport = !((this.state.report || {}).ReportName);
        return <Grid container spacing={2} style={{padding: "24px 14px 24px 14px"}}>
            <Grid item md={12} sm={12} xs={12} style={{textAlign: 'left', display: 'flex', gap: '1em'}}>
                <Typography style={{fontSize: '24px', fontWeight: '600'}}>Scheduled Reports</Typography>
                <div style={{flex: 1}}></div>
                {canManageSettings && <Button onClick={this.newReport} color='primary' variant='contained'><AddCircleOutline style={{marginRight: '10px'}}/>Add report</Button>}
                <Button component={Link} variant='outlined' to='/profile/notifications'>Notifications</Button>
                <Button component={Link} variant='outlined' to='/order-management/advanced-export'>Advanced Export</Button>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12} style={{display: 'flex'}}>
                    <Card style={{flex: 1}}>
                        <Alert severity="info">
                            <Typography style={{textAlign: 'left'}}><span style={{fontWeight: 'bold'}}>Permissions Needed:</span> settings/manage</Typography>
                            <Typography><span style={{fontWeight: 'bold'}}>Note:</span> These reports can be run across your organization but only users with the notification enabled will receive the report through email.</Typography>
                        </Alert>
                    </Card>
            </Grid>
            <Grid item lg={12} md={12} sm={12} xs={12}>
                <StyledTable config={config}/>
            </Grid>
            <ConfirmDialog open={this.state.showConfirm} onClose={() => this.setState({showConfirm: false, report: null})} message={this.state.confirmMessage} onConfirm={() => this.delete(this.state.report)}/>
              <Dialog
                  disableBackdropClick={this.state.disableEdit}
                  disableEscapeKeyDown={this.state.disableEdit}
                  maxWidth="sm"
                  fullWidth
                  open={this.state.showEdit}
                  onClose={() => this.setState({showEdit: false, report: null})}
                  >
                  {this.state.report ?
                  <Form onSubmit={this.save}
                  decorators={[this.calculator]}
                  initialValues={this.state.report}
                  render={({ handleSubmit, pristine, invalid, values }) => (
                    <form onSubmit={handleSubmit} style={{display: 'flex', flexDirection: 'column'}}>
                    <Toolbar className='lbtoolbar'>{creatingReport ? 'Add Report' : `Edit ${this.state.report.ReportAlias}`}</Toolbar>
                  <DialogContent>
                  <div style={{display: 'flex', flexDirection: 'column', flexShrink: '0', gap: '0.5em'}}>
                    {creatingReport && <Field style={{marginBottom: '0.5em'}} label='Report' component={ExtendedSelect} name='ReportAlias'>
                        {this.state.reportNames.map(d => <MenuItem key={d} value={d}>{d}</MenuItem>)}
                    </Field>}
                    {!(!values.ReportId) && <Typography style={{marginBottom: '0.5em'}}>
                        {reportDescriptions[this.state.definitions.filter(r => r.Id === values.ReportId)[0].ReportName]}
                    </Typography>}
                    {this.enableDocType(values.ReportId) && <Field label='Document Type' component={ExtendedSelect} name='DocumentType'>
                        <MenuItem value='Order'>Order</MenuItem>
                        <MenuItem value='AdvanceShipmentNotice'>Shipment</MenuItem>
                        <MenuItem value='Invoice'>Invoice</MenuItem>
                        <MenuItem value='POAck'>Acknowledgement</MenuItem>
                        <MenuItem value='Return'>Return</MenuItem>
                    </Field>}
                    {this.enableExportProfile(values.ReportId) && <><Field label='Export Template' shrink={true} component={ExtendedSelect} name='ExportProfile'>
                        {this.state.profiles.filter(r => r.DocumentType === values.DocumentType).map(r => <MenuItem key={r.Name} value={r.Name}>{r.Name}</MenuItem>)}
                    </Field>
                    <Typography>You may select an export template that is shared with other users at your company. Export templates are configured on the <Link to='/order-management/advanced-export'>Advanced Export</Link> page.</Typography>
                    </>}
                    {!(!values.ReportId) && <Field disabled={!values.ReportAlias} label='Schedule (UTC)' component={ExtendedSelect} name='ReportId'>
                        {this.state.definitions.filter(r => r.ReportAlias === values.ReportAlias).map(d => <MenuItem key={d.Id} value={d.Id}>{d.Schedule}</MenuItem>)}
                    </Field>}
                    {this.enableThreshold(values.ReportId) &&
                    <Field label='Threshold (# of documents to trigger report)' component={ExtendedField} type='number' name='Threshold'/>}
                    </div>
                  </DialogContent>
                  <DialogActions>
                    <Button type='submit' disabled={pristine || invalid || this.state.disableEdit || (this.enableExportProfile(values.ReportId) && !values.ExportProfile)} color="primary">
                      Save
                    </Button>
                  </DialogActions>
                  </form>
              )}/> : ''}
                </Dialog>
                <Dialog
                    maxWidth="md"
                    fullWidth
                    open={this.state.showReport}
                    onClose={() => this.setState({showReport: false})}
                    >
                    <Toolbar className='lbtoolbar'>{this.state.report && this.state.report.ReportAlias}</Toolbar>
                    <DialogContent id="reportContent">
                    {this.state.result ?
                        <Typography className="detailsModalBody" dangerouslySetInnerHTML={{__html: this.state.result}}></Typography>
                     : <LinearProgress style={{height: '2em'}} variant='indeterminate'/>}
                 </DialogContent>
                 {!(!this.state.result) && <DialogActions>
                    {this.state.tables.map(r => <Button key={r.name} onClick={() => this.export(r.name, r.rows)}>Download {r.name}</Button>)}
                   <Button color="primary" onClick={this.print}>Print</Button>
                 </DialogActions>}
                  </Dialog>
                  <Dialog
                    maxWidth="sm"
                    fullWidth
                    open={this.state.showReportDetails}
                    onClose={() => this.setState({showReportDetails: false})}
                    >
                    <Toolbar className='lbtoolbar'>{this.state.report && this.state.report.ReportAlias}</Toolbar>
                    <DialogContent id="reportContent">
                        <Typography>{this.state.report && this.state.report.Description}</Typography>
                        <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'baseline'}}>
                            <Typography style={{color: '#9E9E9E', marginTop: '1em'}}><img style={{marginRight: '10px'}} src={ScheduleIcon} alt='Schedule'/>{this.state.report && this.state.report.Schedule} (UTC)</Typography>
                            {this.state.report && ((this.state.report.DocumentType && this.enableDocType(this.state.report.ReportId)) || reportDocumentTypes[this.state.report.ReportName]) && <Chip size='small' variant='outlined' label={<span style={{color: '#9E9E9E'}}><DocType docType={this.state.report.DocumentType || reportDocumentTypes[this.state.report.ReportName]}/>s</span>}/>}
                        </div>
                        
                    </DialogContent>
                  </Dialog>
        </Grid>;
    }
}

export default Monitoring;
